import request from "@/services/api/request";

const contactCenter = {
  service() {
    return {
      sendSMS(data) {
        return request.post("/contact-center-api/sms", data);
      },
      getTwilioTasks(params) {
        return request.get(
          `/contact-center-api/proxy/twilio-api/tasks`,
          params,
        );

        // return request
        //   .get("/contact-center-api/proxy/twilio-api/tasks", params)
        //   .then(resp => {
        //     console.log("*********************************");
        //     console.log(resp);
        //     console.log("*********************************");
        //     return {
        //       resp: resp,
        //       search: params.opportunityName ? params.opportunityName : ""
        //     };
        //   })
        //   .catch(e => {
        //     throw e;
        //   });
      },
      deleteTwilioTask(tid) {
        return request.delete(
          `/contact-center-api/proxy/twilio-api/tasks/${tid}`,
        );
      },
      validateAddress(data) {
        return request.post(
          "/contact-center-api/proxy/google-api/validate-address",
          data,
          null,
        );
      },
    };
  },
};

export default contactCenter;
